import OneTrustNotice from "presentation/components/OneTrustNotices/OneTrustNotice";

const ModernSlavery = () => (
  <OneTrustNotice
    noticeUrl="https://privacyportal-cdn.onetrust.com/7bc4e376-ade0-4069-b447-79b713984a3b/privacy-notices/d22bbd40-7052-4b5e-bc24-addc8592f06a.json"
    noticeId="otnotice-d22bbd40-7052-4b5e-bc24-addc8592f06a"
  />
);

export default ModernSlavery;
